import { AppState } from "@Store/index";
import getCookie from "helpers/getCookie";
import { useSelector, shallowEqual } from "react-redux";

const useAbTestVariant = (testName: string): string | undefined => {
  const { abTestVariants } = useSelector(
    ({ appData }: AppState) => ({
      abTestVariants: appData.abTestVariants,
    }),
    shallowEqual,
  );
  if (__CLIENT__) {
    const cookieValue = getCookie(testName);
    if (cookieValue) return cookieValue;
  }
  return abTestVariants?.[testName];
};

export default useAbTestVariant;
